import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCArancel {

    public static async ObtieneBecas(rut: number, codigoCarrera: string, anio: number, periodo: number,
        anioPromocion: number, idProceso: number, quiereCAE: boolean, codNegocio: number,
        codigoPlanificacion: number, idPeriodo: number, fechaMatricula: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Beneficio/getMontoBeneficio";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                'rut': rut,
                'codigoCarrera': codigoCarrera,
                "anio": anio,
                "periodo": periodo,
                "anioPromocion": anioPromocion,
                "idProceso": idProceso,
                "quiereCAE": quiereCAE,
                "negocio": codNegocio,
                "codigoPlanificacion": codNegocio === 1 ? 0 : codigoPlanificacion,
                "idPeriodo": idPeriodo,
                "fechaMatricula": fechaMatricula
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtieneReglaBecas(codigoBeneficio: number, codigoSede: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ReglaBeca/getPDFReglaBeca";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    'codigoBeneficio': codigoBeneficio,
                    'codigoSede': codigoSede
                }
            })
            .then((res: AxiosResponse) => {
                /* console.log(res)
                console.log(res.data) */
                const raw = window.atob(res.data)
                const rawlength = raw.length;
                const blobArray = new Uint8Array(new ArrayBuffer(rawlength));

                for (let i = 0; i < rawlength; i++) {
                    blobArray[i] = raw.charCodeAt(i);
                }

                const blob = new Blob([blobArray], { type: 'application/pdf' });

                var fileURL = URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.download = "ReglaBeca.pdf";

                window.open(fileURL)
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });


        return sr;

    }
    public static async ObtieneCAE(rut: number, codigoCarrera: string, anio: number, periodo: number, idProceso: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "CRAEArancelReferencia/getCRAEArancelReferencia";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                'rut': rut,
                'codigoCarrera': codigoCarrera,
                "anio": anio,
                "periodo": periodo,
                "idProceso": idProceso
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }

    public static async ObtieneFormaPagoMulti(rut: number, anio: number, periodo: number, codigoNegocio: number, codigoItem: number, codigoSede: number, codigoTipoAlumno: number,
        promocionDesde: number, promocionHasta: number, codigoOrigen: number, codigoCarrera: string, esCae: boolean, idProceso: number, planificacionAcademica: number, idPeriodo: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "FormaPago/getFormaPagoMulti";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "rut": rut,
                "anioProceso": anio,
                "periodoProceso": periodo,
                "codigoNegocio": codigoNegocio,
                "codigoItem": codigoItem,
                "codigoFormaPago": 0,
                "codigoSede": codigoSede,
                "codigoTipoAlumno": codigoTipoAlumno,
                "promocionDesde": promocionDesde,
                "promocionHasta": promocionHasta,
                "codigoOrigen": codigoOrigen,
                "codigoCarrera": codigoCarrera,
                "esVisible": true,
                "esCae": esCae,
                "excepcionContrato": false,
                "idProceso": idProceso,
                "planificacionAcademica": codigoNegocio === 1 ? 0 : planificacionAcademica,
                "idPeriodo": idPeriodo
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtieneBeneficioComplementario(rut: number, anio: number, periodo: number, beneficio: number, codigoCarrera: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBeneficios();
        const url: string = _ruta + "BeneficiosComplementario/getBeneficioComplementario";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    "beneficio": beneficio,
                    "codigoCarrera": codigoCarrera,
                    "rut": rut,
                    "anio": anio,
                    "periodo": periodo
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async InsertarBeneficioComplementario(rut: number, idBeneficio: number, codPrograma: string, periodo: number, anio: number, sistema: string, idBeneficioC: number, data: any
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBeneficios();
        const url: string = _ruta + "BeneficiosComplementario/saveBeneficioComplementario";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "idcomplementario": idBeneficio,
                "rut": rut,
                "codigoPrograma": codPrograma,
                "anio": anio,
                "periodo": periodo,
                "sistema": sistema,
                "idBeneficio": idBeneficioC,
                "ctaCte": data

            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async QuitarBeneficioComplementario(rut: number, idBeneficio: number, codPrograma: string, periodo: number, anio: number, sistema: string, idBeneficioC: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBeneficios();
        const url: string = _ruta + "BeneficiosComplementario/deleteBeneficioComplementario";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "idcomplementario": idBeneficio,
                "rut": rut,
                "codigoPrograma": codPrograma,
                "anio": anio,
                "periodo": periodo,
                "sistema": sistema,
                "idBeneficio": idBeneficioC

            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async InsertarClienteMandato(rut: number, codigoPrograma: string, anio: number, periodo: number, tipo: string, sistema: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ClienteMandato/saveClienteMandato";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "rut": rut,
                "codigoPrograma": codigoPrograma,
                "anio": anio,
                "periodo": periodo,
                "tipo": tipo,
                "sistema": sistema
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtenerClienteMandato(rut: number, codigoPrograma: string, anio: number, periodo: number, tipo: string, sistema: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ClienteMandato/getClienteMandato";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "rut": rut,
                "codigoPrograma": codigoPrograma,
                "anio": anio,
                "periodo": periodo,
                "tipo": tipo,
                "sistema": sistema
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async EliminarClienteMandato(rut: number, codigoPrograma: string, anio: number, periodo: number, tipo: string, sistema: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ClienteMandato/deleteClienteMandato";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "rut": rut,
                "codigoPrograma": codigoPrograma,
                "anio": anio,
                "periodo": periodo,
                "tipo": tipo,
                "sistema": sistema
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async GuardarFormaPago(data: any, idProceso: number, codigoNegocio: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ProcesoItemPago/saveProcesoItemPago?idProceso=" + idProceso + "&codigoNegocio=" + codigoNegocio;
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, data,
            )
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                sr.errorMessage = "Error al leer";
                sr.errorDetails = err;
            }
            );

        return sr;

    }
    public static async ObtieneProcesoItemPago(headers: any, idProceso: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "GetProcesoItemPagoPorIdProceso";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                headers,
                params: {
                    "idProceso": idProceso
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }

    public static async ObtienePagoTransbank(
        idProceso: number, codigoNegocio: number, monto: number, codigoComercio: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "PagoTransbank/getCreacion";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data,
                {
                    params: {
                        "codigoItem": codigoNegocio,
                        "idProceso": idProceso,
                        "monto": monto,
                        "codigoComercio": codigoComercio
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result ) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async ObtieneResultPagoTransbank(
        token: string, ordenCompra: string, codigoItem: number, codigoComercio: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "PagoTransbank/getReturn";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data,
                {
                    params: {
                        "token": token,
                        "ordenCompra": ordenCompra,
                        "codigoItem": codigoItem,
                        "codigoComercio": codigoComercio
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result ) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public obtenerFecha = (fecha: string) => {
        var f = new Date(fecha)
        var d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate())
        /* console.log(f.getFullYear()+'-'+f.getMonth()+1+'-'+f.getDate()+'T'+f.toLocaleTimeString()) */
        return d
    }
    public static async InsertarExcepcion(
        rut: number, codigoPrograma: string, anio: number, periodo: number, codigoTipoExcepcion: number, codigoExcepcion: number, codigoNegocio: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        var f = new Date()
        var d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate())
        const url: string = _ruta + "ClienteExcepcion/insertClienteExcepcion";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    "codigoClienteExcepcion": 0,
                    "codigoTipoExcepcion": codigoTipoExcepcion,
                    "codigoExcepcion": codigoExcepcion,
                    "rut": rut,
                    "codigoCarreraPrograma": codigoPrograma,
                    "periodo": periodo,
                    "anio": anio,
                    "codigoNegocio": codigoNegocio,
                    "estado": true,
                    "usuario": "",
                    "fecha": d
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result ) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async InsertarComprobante(
        rut: number, codigoPrograma: string, anio: number, periodo: number, base64: string, sistema: string, extension: string, codNegocio: number, codigoPlanificacion: number, idPeriodo: number, idPersona: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GuardarAlumnoDocumento/saveComprobanteTransferencia";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    "rut": rut,
                    "codigoPrograma": codigoPrograma,
                    "sistema": sistema,
                    "extension": extension,
                    "base64": base64,
                    "codNegocio": codNegocio,
                    "anio": anio,
                    "periodo": periodo,
                    "codigoPlanificacion": codNegocio === 1 ? 0 : codigoPlanificacion,
                    "idPeriodo": idPeriodo,
                    "idPersona": idPersona
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result ) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async ObtieneTransferenciaItemPago(headers: any, idItemPago: number, idTransferencia: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "PostTransferenciaBancariaPorAlumno";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, null, {
                headers,
                params: {
                    "idItemPago": idItemPago,
                    "idTransferencia": idTransferencia
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtenerDocumento(guid: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GuardarAlumnoDocumento/getDocumento";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //var data: any = []
        await axios
            .get(url, {
                params: {
                    "guid": guid
                }
            })
            .then((res: AxiosResponse) => {
                /* console.log(res.data) */
                if (res.data.length > 0) {
                    const raw = window.atob(res.data)
                    const rawlength = raw.length;
                    const blobArray = new Uint8Array(new ArrayBuffer(rawlength));

                    for (let i = 0; i < rawlength; i++) {
                        blobArray[i] = raw.charCodeAt(i);
                    }

                    const blob = new Blob([blobArray], { type: 'application/pdf' });

                    var fileURL = URL.createObjectURL(blob);
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = "Documento.pdf";

                    window.open(fileURL)
                }
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result ) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtenerOC(rut: number, idProceso: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "OrdenCompra/getOrdenCompra";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data, {
                params: {
                    "rutAlumno": rut,
                    "idProceso": idProceso
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtieneCtaCtecomplementario(idClienteComplemenatrio: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBeneficios();
        const url: string = _ruta + "BeneficiosComplementario/getCtaCteComplemenatario";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //var data: any = []
        await axios
            .get(url, {
                params: {
                    "idClienteComplemenatrio": idClienteComplemenatrio
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async UpdateCtaCtecomplementario(idClienteComplemenatrio: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBeneficios();
        const url: string = _ruta + "BeneficiosComplementario/updateCtaCteComplemenatario";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data, {
                params: {
                    "idClienteComplemenatrio": idClienteComplemenatrio
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtieneMesesPago(rut: number, dia: number, negocio: number, carrera: string, mes: string, codigoPlanificacion: number, idPeriodo: number, idPersona: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "FormaPago/getFormaPagoMeses";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, {
                "rut": rut,
                "dia": dia,
                "negocio": negocio,
                "carrera": carrera,
                "mes": mes,
                "codigoPlanificacion": negocio === 1 ? 0 : codigoPlanificacion,
                "idPeriodo": idPeriodo === null ? 0 : idPeriodo,
                "idPersona": idPersona === null ? 0 : idPersona
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
    public static async ObtieneCuotasPago(rut: number, dia: number, negocio: number, codigoItem: number, carrera: string, mes: string, codigoPlanificacion: number, idPeriodo: number, idPersona: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "FormaPago/getCuotaMaxima";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, {
                "rut": rut,
                "dia": dia,
                "negocio": negocio,
                "codigoItem": codigoItem,
                "carrera": carrera,
                "mes": mes === "" ? 0 : mes,
                "codigoPlanificacion": negocio === 1 ? 0 : codigoPlanificacion,
                "idPeriodo": idPeriodo === null ? 0 : idPeriodo,
                "idPersona": idPersona === null ? 0 : idPersona
            }
            )
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }

    public static async ObtieneCodComercio(negocio: number, carrera: string, codItem: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "FormaPago/getCodigoComercio";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //var data: any = []
        await axios
            .post(url, {
                "negocio": negocio,
                "codigoItem": codItem,
                "codigoPrograma": carrera
            }
            )
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }

    public static async ObtenerFecha1erPago(idProceso: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ProcesoItemPago/getFechaPrimerPago";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //var data: any = []
        await axios
            .get(url, {
                params: {
                    "idProceso": idProceso
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }

    public static async ObtieneSaldosPendientesPorPagar(headers: any, rut: number, codigoCarrera: string, codSede: number, idProceso: number,
        quiereCAE: boolean, codNegocio: number, codigoPlanificacion: number, idPeriodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "GetSaldosPendientesPorRut";//?negocio=2&rut=6460983&codCarrera=030001C&codPlanificacion=202504&idPersona=411027&quiereCae=false&codSede=1&excepcionContrato=false&idPeriodo=0&idProceso=87506
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                headers,
                params: {
                    "negocio": codNegocio,
                    'rut': rut,
                    'codCarrera': codigoCarrera,
                    "codPlanificacion": codNegocio === 1 ? 0 : codigoPlanificacion,
                    "quiereCae": quiereCAE,
                    "codSede": codSede,
                    "idPeriodo": idPeriodo,
                    "idProceso": idProceso
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
}